/** Light palette (clean-light / editorial templates) */
export const colors = {
  primary: "#004ac6",
  primaryContainer: "#2563eb",
  primaryFixed: "#dbe1ff",
  onPrimary: "#ffffff",
  onPrimaryFixed: "#00174b",

  surface: "#f7f9fb",
  surfaceContainerLowest: "#ffffff",
  surfaceContainerLow: "#f2f4f6",
  surfaceContainerHigh: "#e6e8ea",

  onSurface: "#191c1e",
  onSurfaceVariant: "#434655",

  tertiary: "#943700",
  error: "#ba1a1a",

  outline: "#737686",
  outlineVariant: "#c3c6d7",
} as const;

/** Dark premium palette for cinematic reels */
export const dark = {
  bg: "#08090d",
  surface: "rgba(255,255,255,0.06)",
  surfaceHover: "rgba(255,255,255,0.10)",
  border: "rgba(255,255,255,0.08)",
  borderSubtle: "rgba(255,255,255,0.04)",
  text: "#ffffff",
  textSecondary: "rgba(255,255,255,0.5)",
  textTertiary: "rgba(255,255,255,0.3)",
  accentBlue: "#2563eb",
  accentBlueMuted: "#60a5fa",
  accentRed: "#ef4444",
  accentRedSubtle: "rgba(239,68,68,0.15)",
  starGold: "#f59e0b",
  glowBlue: "0 0 60px rgba(37,99,235,0.08)",
  glowBlueStrong: "0 0 80px rgba(37,99,235,0.15)",
  glowRed: "0 0 60px rgba(239,68,68,0.06)",
} as const;

export const fonts = {
  headline: "Public Sans, system-ui, sans-serif",
  body: "Inter, system-ui, sans-serif",
  mono: "JetBrains Mono, monospace",
} as const;

/** Safe zones for vertical Reels (accounts for UI overlays) */
export const safeZone = {
  top: 192, // ~10% of 1920
  bottom: 384, // ~20% of 1920
  horizontal: 64,
} as const;

export const gradients = {
  primary: "linear-gradient(135deg, #004ac6, #2563eb)",
  dark: "linear-gradient(180deg, #0a0f1a, #111827)",
  /** Radial blue glow for dark premium scenes */
  darkGlow: `radial-gradient(ellipse 600px 600px at 50% 50%, rgba(37,99,235,0.12), transparent)`,
  darkGlowStrong: `radial-gradient(ellipse 700px 700px at 50% 50%, rgba(37,99,235,0.20), transparent)`,
} as const;

/* ── Template-specific palettes ── */

export const cleanLight = {
  bg: "#ffffff",
  surface: "#f8f9fa",
  surfaceHigh: "#f0f1f3",
  text: "#1a1a2e",
  textMuted: "#6b7280",
  textSubtle: "#9ca3af",
  accent: "#2563eb",
  accentHover: "#1d4ed8",
  border: "#e5e7eb",
  success: "#16a34a",
  warning: "#d97706",
  error: "#dc2626",
};

export const neonPop = {
  bg: "#0d0d0d",
  surface: "#1a1a2e",
  surfaceHigh: "#16213e",
  text: "#ffffff",
  textMuted: "#c4b5fd",
  textSubtle: "#7c3aed",
  accent: "#a855f7",
  accentHover: "#7c3aed",
  accentCyan: "#00f0ff",
  accentMagenta: "#ff2d95",
  accentGreen: "#39ff14",
  border: "#2d1b69",
  success: "#34d399",
  warning: "#fbbf24",
  error: "#f43f5e",
};

export const editorial = {
  bg: "#faf9f6",
  surface: "#f5f3ee",
  surfaceHigh: "#edeae3",
  text: "#1c1917",
  textMuted: "#57534e",
  textSubtle: "#a8a29e",
  accent: "#b45309",
  accentHover: "#92400e",
  border: "#d6d3d1",
  success: "#15803d",
  warning: "#a16207",
  error: "#b91c1c",
};

export const gradientFlow = {
  bg: "#030712",
  surface: "#111827",
  surfaceHigh: "#1f2937",
  text: "#f9fafb",
  textMuted: "#9ca3af",
  textSubtle: "#6b7280",
  accent: "#06b6d4",
  accentHover: "#0891b2",
  border: "#1f2937",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  gradientStart: "#7c3aed",
  gradientEnd: "#06b6d4",
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
